<template>
  <Modal
    v-model="editListModal"
    width="700"
    title="申请开票"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
  <div class="block">
    <div class="line"
      v-for="(Apply, index) in selectionOne"
      value="Apply.index"
      key="Apply.index"
    >
      <div class="line-name">
        {{Apply.order_no}}
      </div>
      <div class="line-value"
      >
        {{'￥'+Apply.special_agent_price}}
      </div>
    </div>
    <div class="allNumble">
      <div class="right">
          发票总金额：{{allMoney}}
      </div>
      <div class="left">
          订单数：{{spanValue}}
      </div>
    </div>
  </div>
    <Form
      ref="editListForm"
      label-position="right"
      :label-width="120"
      :rules="ruleValidate"
      :model="editListForm"
    >
    <FormItem label="发票类型"
      label-for="type"
    >
    <RadioGroup
      v-model="leven"
      style="display:inline-block"
      vertical>
      <Radio style="display:inline-block" label="1">增值税普通发票</Radio>
      <Radio style="display:inline-block" label="2">增值税专用发票</Radio>
    </RadioGroup>
    </FormItem>
    <FormItem label="选择发票信息"
      label-for="message"
    >
      <Button
        style="margin-right:10px;"
        v-for="(orderList,index) in list"
        :key="orderList.id"
        :name="orderList.id"
        @click="message(orderList.id)"
      >
      {{orderList.name}}
      </Button>
    </FormItem>
    <FormItem label="发票抬头"
      prop="title"
      label-for="title"
    >
      <Input
        placeholder="请输入发票抬头"
        element-id="title"
        v-model="editListForm.title"
      ></Input>
    </FormItem>
    <FormItem label="纳税人识别号"
      prop="taxpayer_number"
      label-for="taxpayer_number"
    >
      <Input
        placeholder="请输入纳税人识别号"
        element-id="taxpayer_number"
        v-model="editListForm.taxpayer_number"
      ></Input>
    </FormItem>
    <FormItem label="开户行"
      prop="bank_name"
      label-for="bank_name"
    >
      <Input
        placeholder="请输入开户行"
        element-id="bank_name"
        v-model="editListForm.bank_name"
      ></Input>
    </FormItem>
    <FormItem label="对公账号"
      prop="bank_account"
      label-for="bank_account"
    >
      <Input
        placeholder="请输入对公账号"
        element-id="bank_account"
        v-model="editListForm.bank_account"
      ></Input>
    </FormItem>
    <FormItem label="注册地址"
      prop="register_addr"
      label-for="register_addr"
    >
      <Input
        placeholder="请输入注册地址"
        element-id="register_addr"
        v-model="editListForm.register_addr"
      ></Input>
    </FormItem>
    <FormItem label="公司电话"
      prop="company_phone"
      label-for="company_phone"
    >
      <Input
        placeholder="请输入公司电话"
        element-id="company_phone"
        v-model="editListForm.company_phone"
      ></Input>
    </FormItem>
    <FormItem label="收件人"
      prop="recipients_name"
      label-for="recipients_name"
    >
      <Input
        placeholder="请输入收件人"
        element-id="recipients_name"
        v-model="editListForm.recipients_name"
      ></Input>
    </FormItem>
    <FormItem label="手机号"
      prop="recipients_phone"
      label-for="recipients_phone"
    >
      <Input
        placeholder="请输入手机号"
        element-id="recipients_phone"
        v-model="editListForm.recipients_phone"
      ></Input>
    </FormItem>
    <FormItem label="邮政编码"
      prop="recipients_postcode"
      label-for="recipients_postcode"
    >
      <Input
        placeholder="请输入邮政编码"
        element-id="recipients_postcode"
        v-model="editListForm.recipients_postcode"
      ></Input>
    </FormItem>
    <FormItem label="收件地址"
      prop="recipients_addr"
      label-for="recipients_addr"
    >
      <Input
        placeholder="请输入收件地址"
        element-id="recipients_addr"
        v-model="editListForm.recipients_addr"
      ></Input>
    </FormItem>
  </Form>
</Modal>
</template>

<script>
export default {
  props: {
    selectionOne: {
      type: Array,
      required: true
    },
    editModal: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    spanValue () {
      return this.selectionOne.length
    },
    allMoney () {
      let all = ''
      this.selectionOne.forEach((item) => {
        all += item.special_agent_price
      })
      return all
    }
  },
  data () {
    return {
      leven: '1',
      editListModal: false,
      loading: false,
      list: [],
      listId: {},
      editListForm: {
        title: '',
        taxpayer_number: '',
        bank_name: '',
        bank_account: '',
        register_addr: '',
        company_phone: '',
        recipients_name: '',
        recipients_phone: '',
        recipients_postcode: '',
        recipients_addr: ''
      },
      ruleValidate: {
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        taxpayer_number: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入对公账号', trigger: 'blur' }
        ],
        register_addr: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        company_phone: [
          { required: true, message: '请输入公司电话', trigger: 'blur' }
        ],
        recipients_name: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        recipients_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        recipients_postcode: [
          { required: true, message: '请输入邮政编码', trigger: 'blur' }
        ],
        recipients_addr: [
          { required: true, message: '请输入收件地址', trigger: 'blur' }
        ]
      }

    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    },
    leven (val) {
      this.leven = val
    }
  },
  methods: {
    message (val) {
      this.$http.get(`/invoiceTmpl/info/${val}`).then(res1 => {
        this.listId = res1.data
        this.editListForm.title = this.listId.title
        this.editListForm.taxpayer_number = this.listId.taxpayer_number
        this.editListForm.bank_name = this.listId.bank_name
        this.editListForm.bank_account = this.listId.bank_account
        this.editListForm.register_addr = this.listId.register_addr
        this.editListForm.company_phone = this.listId.company_phone
        this.editListForm.recipients_name = this.listId.recipients_name
        this.editListForm.recipients_phone = this.listId.recipients_phone
        this.editListForm.recipients_postcode = this.listId.recipients_postcode
        this.editListForm.recipients_addr = this.listId.recipients_addr
      })
    },
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let orderIds = []
          this.selectionOne.forEach((item) => {
            orderIds.push(item.id)
          })
          console.log(orderIds)
          let data = {
            type: this.leven,
            orderIds: orderIds,
            ...this.editListForm
          }
          let url = '/invoice'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              this.$Message.success('申请开票成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.leven = '1'
      this.editListForm = {
        title: '',
        taxpayer_number: '',
        bank_name: '',
        bank_account: '',
        register_addr: '',
        company_phone: '',
        recipients_name: '',
        recipients_phone: '',
        recipients_postcode: '',
        recipients_addr: ''
      }
    }
  },
  created () {
    this.$http.get(`/invoiceTmpl/list?pageIndex=0&pageSize=1000`).then(res => {
      this.list = res.data
    })
  }
}
</script>
<style lang="less" scoped>
.block {
  padding-bottom: 12px 20px;
  .allNumble{
    display: flex;
    flex-direction: row-reverse;
    padding: 18px 0;
    .left{
      width: 120px;
    }
  }
  .line {
    display: flex;
    line-height: 32px;
    padding: 4px 12px;
    border: 1px solid #e3e3e3;
    .line-name {
      width: 300px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 168px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848F;
      overflow: hidden;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceApply/editInvoiceApply.vue